import { gql } from '@apollo/client';

export const IMPORT_CUSTOMERS = gql`
  mutation ImportCustomers($file: Upload!, $updateDuplicated: Boolean, $searchField: String) {
    importCustomers(input: { file: $file, updateDuplicated: $updateDuplicated, searchField: $searchField }) {
      message
      errors
    }
  }
`;